export default __webpack_public_path__ + "static/media/91b5ad9c13464aee.572aba51a6826a0a56b6fc4e76a5c04d.svg";